import { Component, input, TemplateRef, ViewChild } from '@angular/core';

@Component({
  selector: 'app-tab',
  standalone: true,
  templateUrl: './tab.component.html',
})
export class TabComponent {
  title = input<string>();
  @ViewChild('templateRef', { read: TemplateRef })
  templateRef!: TemplateRef<unknown>;
}
